const DEFAULT_EVENT_IMAGE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300"><rect width="400" height="300" fill="#F0EDE6"/><g fill="none" stroke="#B4006E" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" opacity="0.55"><rect x="110" y="90" width="180" height="120" rx="10"/><circle cx="150" cy="125" r="12"/><path d="M110 190 L160 150 L200 180 L240 140 L290 190"/></g></svg>`;

export const DEFAULT_EVENT_IMAGE = `data:image/svg+xml;utf8,${encodeURIComponent(
  DEFAULT_EVENT_IMAGE_SVG
)}`;
